import React from 'react';
import {
    TextWrapper,
    TopLine,
    SelectButton,
    SlotCard
} from './TeamDisplayElements';
import { post } from 'aws-amplify/api';

const TeamSlotCard = ({ position, handleFill }) => {


    var sendPosition = "WR";

    if (position == "Quarterback") {
        sendPosition = "QB"
    }
    else if (position === "Wide Receiver") {
        sendPosition = "WR"
    }
    else if (position === "Running Back") {
        sendPosition = "RB"
    }
    else if (position === "Tight End") {
        sendPosition = "TE"
    }
    else if (position === "Defense / Special Teams") {
        sendPosition = "DST"
    }
    else if (position === "Captain") {
        sendPosition = "CPT"
    }
    else if (position === "Flex") {
        sendPosition = "FLEX"
    }
    else {
        sendPosition = "WR"
    }

    return (
        <>
            {/* <TopLine>{position}</TopLine> */}
            <SlotCard>
                {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
                <TextWrapper>
                    <TopLine>{position}</TopLine>
                </TextWrapper>
                <SelectButton style={{ justifySelf: 'center' }} onClick={(e) => handleFill(e, position = sendPosition)}>Fill</SelectButton>
            </SlotCard>
        </>
    );
};

export default TeamSlotCard;
